import { render } from "./DeviceTabGeneral.vue?vue&type=template&id=6bf42c44"
import script from "./DeviceTabGeneral.vue?vue&type=script&lang=js"
export * from "./DeviceTabGeneral.vue?vue&type=script&lang=js"

import "./DeviceTabGeneral.vue?vue&type=style&index=0&id=6bf42c44&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__